import React from 'react';

const IconRefreshTwo = props => (
  <svg viewBox="0 0 20 21.5" {...props}>
    <title>Refresh</title>
    <path d="M17.4 4.7c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7 1.5 1.7 2.4 3.8 2.4 6.1 0 5-4 9-9 9-1.4 0-2.7-.3-4-.9-.9-.4-1.7-1-2.4-1.7-1.8-1.8-2.7-4-2.7-6.4C1 7 4.3 3.4 8.5 2.6v.9c0 .2.1.3.2.4.1.1.2.1.3.1.1 0 .2 0 .2-.1l3-1.5c.2-.1.3-.3.3-.4s-.1-.4-.3-.4L9.2.1c-.1-.1-.3-.1-.5 0-.1.1-.2.2-.2.4v1.1C3.7 2.4 0 6.5 0 11.5c0 2.7 1 5.2 2.9 7 .8.8 1.7 1.4 2.7 1.9 1.4.7 2.9 1 4.4 1 5.5 0 10-4.5 10-10 0-2.4-.9-4.8-2.6-6.7z" />
  </svg>
);

export default IconRefreshTwo;
